import {
  Box,
  Checkbox,
  Icon,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CoreTypographyBody1 from "../CoreTypographyBody1";
import { CoreDataTableToolbar } from "./CoreDataTableToolbar";
import { theme } from "../../../config/theme";
import CorePopOver from "../../layouts/CorePopOver";
import ActionPopOver from "./ActionPopOver";
import EditableCell from "./EditableCell";
import CustomPagination from "./CustomPagination";

export default function CoreDataTableDashboard(props) {
  const {
    size = "small",
    ariaLable = "a dense table",
    rows = [],
    columns,
    actions,
    rowActions,
    containerStyle = { marginTop: 1 },
    showToolbar = true,
    noOfRows = 10,
    dense = true,
    pagination = true,
    elevation = true,
    selectable = true,
    editable = false,
    onSave,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(noOfRows);
  const [hoveredElement, setHoveredelement] = useState(null);
  const [selections, setSelections] = useState([]);
  const [allSelected, setSelectAll] = useState(false);
  const [editId, setEditable] = useState(null);
  const [editCol, setEditCol] = useState(null);
  const [val, setVal] = useState("");

  useEffect(() => {
    setSelections([]);
    setSelectAll(false);
  }, [rows]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handlePopoverOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setHoveredelement(row);
  };

  const handlePopoverClose = (e) => {
    console.log("release ", e.currentTarget);
    setAnchorEl(null);
    setHoveredelement(null);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event?.target?.value, 10));
    setPage(0);
  };

  const changeSelctions = (row) => {
    let idList = [...(selections || [])];
    if (selections?.includes(row.id)) {
      idList = idList.filter((id) => id !== row.id);
    } else {
      idList.push(row.id);
    }
    setSelections(idList);
  };

  const changeAllSelctions = () => {
    if (!allSelected)
      setSelections(
        visibleRows?.map((row) => {
          return row.id;
        }),
      );
    else {
      setSelections([]);
    }
    setSelectAll(!allSelected);
  };

  const setEditMode = (id, val, row, col) => {
    console.log("edit called");
    setAnchorEl(null);

    setEditCol(col);
    if (typeof id === "function") {
      console.log(id(row));

      setEditable(id(row));
    } else {
      setEditable(id);
    }

    setVal(val);
  };

  const changeHandler = (e) => {
    setVal(e?.target?.value);
  };

  const onCancel = (e) => {
    console.log("cancel", e?.target?.id);

    setEditable(null);
    setVal("");
    setEditCol(null);
  };

  let table_columns = columns
    ? columns
    : rows?.length > 0
      ? Object.keys(rows[0]).map((col) => {
          return { label: col, name: col, key: col };
        })
      : [];

  const visibleRows = React.useMemo(
    () => rows?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [page, rowsPerPage, rows],
  );

  console.log("ROWS", selections);

  return table_columns && rows?.length > 0 ? (
    <Box sx={containerStyle}>
      {showToolbar && (
        <CoreDataTableToolbar
          rowActions={rowActions}
          actions={actions}
          selections={selections}
        />
      )}

      <TableContainer
        style={{ boxShadow: "none" }}
        component={elevation ? Paper : Box}
      >
        <Table
          style={{ borderCollapse: "separate", borderSpacing: "4px" }}
          size={size}
          aria-label={ariaLable}
          {...props}
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ border: "none" }}></TableCell>
              {selectable ? (
                <TableCell
                  padding="checkbox"
                  style={{ width: "1%", border: "none" }}
                >
                  <Checkbox
                    color="primary"
                    checked={allSelected}
                    onChange={changeAllSelctions}
                    inputProps={
                      {
                        // 'aria-labelledby': labelId,
                      }
                    }
                  />
                </TableCell>
              ) : null}
              {table_columns?.map((d, key) => (
                <TableCell
                  padding={dense ? "none" : "normal"}
                  sx={{
                    minWidth: d.width ? d.width : "150px",
                    maxWidth: d.width ? d.width : "150px",
                    width: d.width ? d.width : "150px",
                    border: "none",
                  }}
                  key={d.key || key}
                  style={
                    d.name === editCol || d.label === editCol
                      ? { minWidth: 200, paddingLeft: "8px" }
                      : { paddingLeft: "8px" }
                  }
                >
                  {d.label}
                </TableCell>
              ))}
              {rowActions ? (
                <TableCell style={{ border: "none" }}></TableCell>
              ) : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows?.map((row, keyR) => (
              <TableRow
                key={row.id}
                aria-owns={anchorEl ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
                onMouseEnter={(e) => {
                  handlePopoverOpen(e, row);
                }}
                checked={selections?.includes(row.id)}
                style={{ minHeight: 30 }}
              >
                <TableCell
                  style={{
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Icon color="primary" style={{ fontSize: 32 }}>
                    folder
                  </Icon>
                  <span
                    style={{
                      color: "white",
                      marginLeft: keyR > 8 ? "-24px" : "-18px",
                      fontSize: 12,
                    }}
                  >
                    {keyR + 1}
                  </span>
                </TableCell>

                {selectable ? (
                  <TableCell
                    padding="checkbox"
                    style={{
                      width: "1%",
                      border: "1px solid black",
                      borderRightColor: "white",
                    }}
                  >
                    <Checkbox
                      color="primary"
                      checked={selections?.includes(row.id)}
                      onChange={(e) => {
                        changeSelctions(row);
                      }}
                      inputProps={
                        {
                          // 'aria-labelledby': labelId,
                        }
                      }
                    />
                  </TableCell>
                ) : null}
                {table_columns?.map((col, ind) => (
                  <TableCell
                    title={String(col.view ? col.view(row) : row[col.name])}
                    padding={dense ? "none" : "normal"}
                    sx={{
                      border: "1px solid",
                      borderColor: theme.palette.grey[300],
                      borderRightColor: "white",
                      borderTopLeftRadius: ind === 0 ? "10px" : 0,
                      borderBottomLeftRadius: ind === 0 ? "10px" : 0,
                      borderLeftColor:
                        ind > 0
                          ? theme.palette.background.default
                          : theme.palette.grey[300],
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      minWidth: col.width ? col.width : "150px",
                      maxWidth: col.width ? col.width : "150px",
                      width: col.width ? col.width : "150px",
                      paddingLeft: "8px",
                      paddingRight: dense
                        ? "8px"
                        : ind < table_columns.length - 1
                          ? 0
                          : "8px",
                    }}
                    key={`${col.name}-${row.id}`}
                    style={
                      col.name === editCol || col.label === editCol
                        ? { minWidth: 200 }
                        : {}
                    }
                  >
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: isNaN(
                          col.view ? Number(col.view(row)) : row[col.name],
                        )
                          ? "flex-start"
                          : "flex-end",
                      }}
                    >
                      <Box
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: isNaN(
                            col.view ? Number(col.view(row)) : row[col.name],
                          )
                            ? "flex-start"
                            : "flex-end",
                        }}
                        onClick={() => {
                          if (editable) {
                            setEditMode(
                              col.id,
                              col.view ? col.view(row) : row[col.name],
                              row,
                              col.name || col.label,
                            );
                          }
                        }}
                      >
                        <EditableCell
                          editId={editId}
                          col={col}
                          val={val}
                          onEdit={changeHandler}
                          onCancel={onCancel}
                          onSave={onSave}
                          row={row}
                        />
                      </Box>
                      {(typeof col.id === "function" &&
                        col.id(row) === editId) ||
                      col.id === editId ? (
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: 8,
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={() => {
                              if (typeof col.id === "function")
                                onSave(col.id(row), val);
                              else {
                                onSave(col.id, val);
                              }
                              onCancel();
                            }}
                          >
                            <Icon style={{ fontSize: 22 }}>save</Icon>
                          </IconButton>
                          <IconButton size="small" onClick={onCancel}>
                            <Icon style={{ fontSize: 22 }}>cancel</Icon>
                          </IconButton>
                        </Box>
                      ) : null}
                    </Box>
                  </TableCell>
                ))}
                <TableCell
                  style={{
                    border: "1px solid",
                    borderColor: theme.palette.grey[300],
                    borderLeftColor: theme.palette.background.default,
                    marginLeft: "-8px",
                    borderTopRightRadius: "10px",
                    borderBottomRightRadius: "10px",
                  }}
                >
                  {rowActions?.map((action, i) => (
                    <IconButton
                      key={"datatable-action-" + hoveredElement?.id + "-" + i}
                      style={
                        i > 0
                          ? {
                              marginLeft: 8,
                            }
                          : {}
                      }
                      disableFocusRipple={true}
                      id="datatable-action"
                      size="small"
                      color="primary"
                      onClick={() => {
                        action.onClick(hoveredElement);
                      }}
                    >
                      {action.title ? (
                        <Tooltip title={action.title}>
                          <Icon
                            id="datatable-action"
                            style={action.style || { fontSize: 14 }}
                          >
                            {action.icon}
                          </Icon>
                        </Tooltip>
                      ) : (
                        <Icon
                          id="datatable-action"
                          style={action.style || { fontSize: 14 }}
                        >
                          {action.icon}
                        </Icon>
                      )}
                    </IconButton>
                  ))}
                </TableCell>
              </TableRow>
            ))}
            {visibleRows?.length < 10 && (
              <TableRow>
                <TableCell
                  style={{
                    border: "none",
                  }}
                ></TableCell>
                {selectable && <TableCell></TableCell>}
                {table_columns?.map((col) => (
                  <TableCell
                    style={{
                      border: "none",
                      padding: dense ? "none" : "normal",
                      minHeight: (10 - visibleRows?.length) * 50,
                      height: (10 - visibleRows?.length) * 50,
                    }}
                  ></TableCell>
                ))}
                {rowActions?.map((col) => (
                  <TableCell
                    style={{
                      border: "none",
                    }}
                  ></TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          ActionsComponent={CustomPagination}
          labelRowsPerPage
          component="div"
          style={{
            backgroundColor: theme.palette.background.paper,
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
          }}
          labelDisplayedRows={() => {
            return null;
          }}
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </Box>
  ) : (
    <CoreTypographyBody1>No data</CoreTypographyBody1>
  );
}
